import "core-js/modules/es.regexp.exec.js";
import React, { lazy, Suspense } from 'react';
import { ErrorNamespaceProvider, BlockingErrorBoundary, Show } from '@edreamsodigeo/frontend-core';
const PrimeFreeCancellationFunnel = /*#__PURE__*/lazy(() => import('./Funnel'));
const primeFreeCancellationPagesRegex = /\/travel\/prime\/membership\//;
export const FreeCancellationFunnel = () => /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
  namespace: "shell_funnel_free_cancellation"
}, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
  name: "funnel_free_cancellation"
}, /*#__PURE__*/React.createElement(Show, {
  when: primeFreeCancellationPagesRegex.test(window.location.href)
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(PrimeFreeCancellationFunnel, null)))));